{
  "approvals": {
    "title": "Dagen",
    "charactersShort": "tkn",
    "tooltips": {
      "openPreview": "Öppna förhandsgranskning",
      "openPlanning": "Öppna planering",
      "lastChanged": "Senast ändrad",
      "scheduledAt": "Schemalagd kl"
    }
  },
  "plannings": {
    "label": {
      "plural": "Planeringar",
      "singular": "Planering"
    },
    "toasts": {
      "create": {
        "success": "Planering skapad"
      },
      "openItem": "Öppna planering"
    }
  },
  "events": {
    "label": {
      "plural": "Händelser",
      "singular": "Händelse"
    },
    "columnLabels": {
      "startTime": "Starttid",
      "status": "Status",
      "organiser": "Organisatör",
      "section": "Sektion",
      "planningStatus": "Planeringsstatus",
      "action": "Action"
    },
    "tooltips": {
      "organiser": "Organisatör"
    }
  },
  "assignments": {
    "title": "Uppdrag",
    "columnLabels": {
      "assignmentTime": "Uppdragstid",
      "type": "Typ"
    },
    "tooltips": {
      "assignmentStartTime": "Uppdragets starttid"
    },
    "actionMenu": {
      "openArticle": "Öppna artikel",
      "openPlanning": "Öppna planering"
    },
    "myAssignments": "Mina uppdrag"
  },
  "factboxes": {
    "title": "Faktarutor",
    "columnLabels": {
      "description": "Beskrivning",
      "lastChanged": "Senast ändrad",
      "origin": "Ursprung"
    },
    "origin": {
      "original": "Original",
      "inArticle": "Från artikel"
    }
  },
  "search": {
    "title": "Sök",
    "placeholders": {
      "search": "Sök"
    },
    "labels": {
      "plannings": "Planeringar",
      "events": "Händelser",
      "articles": "Artiklar"
    },
    "columnLabels": {
      "date": "Datum"
    }
  },
  "login": {
    "loginWith": "Logga in med",
    "rememberMe": "Kom ihåg mig nästa gång",
    "loggingIn": "Loggar in..."
  },
  "timeless": {
    "title": "Tidlös",
    "columnLabels": {
      "category": "Kategori",
      "lastChanged": "Senast ändrad",
      "actions": "Åtgärder"
    },
    "toolbar": {
      "allCategories": "Alla kategorier"
    },
    "actions": {
      "new": "Ny tidlös",
      "openPlanning": "Öppna ursprunglig planering",
      "convertToArticle": "Planera som artikel"
    },
    "placeholders": {
      "addCategory": "Lägg till kategori"
    },
    "toasts": {
      "articlePlanned": "Artikel planerad",
      "timelessSaved": "Tidlös sparad",
      "conversionFailed": "Kunde inte skapa det nya dokumentet: {{message}}",
      "notAuthenticated": "Kan inte konvertera: inte inloggad",
      "documentNotFound": "Dokumentet hittades inte",
      "openArticle": "Öppna artikel",
      "openTimeless": "Öppna tidlös",
      "openPlanning": "Öppna planering"
    }
  },
  "imageSearch": {
    "title": "Bilder",
    "labels": {
      "mediaType": "Medietyp",
      "distributor": "Distributör",
      "allDistributors": "Alla distributörer",
      "image": "Bild",
      "graphic": "Grafik",
      "close": "Stäng",
      "searchFailed": "Bildsökningen misslyckades",
      "retry": "Försök igen",
      "noResults": "Inga resultat"
    }
  }
}
